import React, { useState, useContext, useEffect } from "react";
import './sideBar.scss';
import { NavLink } from 'react-router-dom';
import logoImage from '../../../assets/images/ZR.png';
import { LuLayoutDashboard, LuFileBarChart } from "react-icons/lu";
import { AiOutlineSolution } from "react-icons/ai";
import { HiOutlineCog6Tooth, HiOutlineUserGroup } from "react-icons/hi2";
import { PiIdentificationCardLight } from "react-icons/pi";
import { RxHamburgerMenu } from "react-icons/rx";
import { FunctionalityNames } from "../../../enum/enum";
import { IoMenuOutline } from "react-icons/io5";
import { FiChevronLeft } from "react-icons/fi";
import { AuthContext } from "../../../context/AuthContext";
import { getPermissionRights, getPermissionRightsForMenu } from "../../../utils/common";

export default function SideBar({ handleToggle }) {
  const { rolePermissions } = useContext(AuthContext);

  // Permission states for each functionality
  const [dashboardPerm, setDashboardPerm] = useState({});
  const [jobListPerm, setJobListPerm] = useState({});
  const [candidatePerm, setCandidatePerm] = useState({});
  const [usersPerm, setUsersPerm] = useState({});
  const [reportPerm, setReportPerm] = useState({});
  const [settingsPerm, setSettingsPerm] = useState({});

  useEffect(() => {
    if (rolePermissions) {
      // Extract permissions for each functionality from the rolePermissions array
      setDashboardPerm(getPermissionRights(rolePermissions, FunctionalityNames.DASHBOARD));
      setJobListPerm(getPermissionRights(rolePermissions, FunctionalityNames.JOBLIST));
      setCandidatePerm(getPermissionRights(rolePermissions, FunctionalityNames.CANDIDATE));
      setUsersPerm(getPermissionRights(rolePermissions, FunctionalityNames.USERS));
      setReportPerm(getPermissionRights(rolePermissions, FunctionalityNames.REPORT));
      setSettingsPerm(getPermissionRights(rolePermissions, FunctionalityNames.SETTINGS));
    }
  }, [rolePermissions]);

  return (
    <section className="sideBar">
      <button className="togle-btn" onClick={handleToggle}>
        <span className="desktop-nav-icon">
          <FiChevronLeft />
        </span>
        <span className="mobile-nav-icon">
          <IoMenuOutline />
        </span>
      </button>
      <a className="logo">
        <img src={logoImage} alt="ZeaRecruit" />
      </a>
      <nav>
        {getPermissionRightsForMenu(dashboardPerm) && (
          <NavLink className="nav-link" activeclassname="active" to="/dashboard">
            <span className="icon strok-svg">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="27.5"
                height="29.362"
                viewBox="0 0 27.5 29.362"
              >
                <g id="dashboard-svgrepo-com" transform="translate(-4.75 -3.249)">
                  <path
                    id="Path_615"
                    data-name="Path 615"
                    d="M13.7,10H8.438A2.914,2.914,0,0,0,5.5,12.89V23.827a2.914,2.914,0,0,0,2.938,2.888H13.7a2.914,2.914,0,0,0,2.938-2.89V12.89A2.914,2.914,0,0,0,13.7,10Z"
                    transform="translate(0 5.143)"
                    fill="none"
                    stroke="#888"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="1.5"
                    fillRule="evenodd"
                  />
                  <path
                    id="Path_616"
                    data-name="Path 616"
                    d="M13.7,4H8.438A2.86,2.86,0,0,0,5.5,6.774V8.657A2.86,2.86,0,0,0,8.438,11.43H13.7a2.86,2.86,0,0,0,2.938-2.773V6.774A2.86,2.86,0,0,0,13.7,4Z"
                    transform="translate(0 0)"
                    fill="none"
                    stroke="#888"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="1.5"
                    fillRule="evenodd"
                  />
                  <path
                    id="Path_617"
                    data-name="Path 617"
                    d="M16.438,20.715H21.7a2.914,2.914,0,0,0,2.94-2.89V6.89A2.914,2.914,0,0,0,21.7,4H16.438A2.914,2.914,0,0,0,13.5,6.89V17.825a2.914,2.914,0,0,0,2.938,2.89Z"
                    transform="translate(6.857 0.001)"
                    fill="none"
                    stroke="#888"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="1.5"
                    fillRule="evenodd"
                  />
                  <path
                    id="Path_618"
                    data-name="Path 618"
                    d="M16.438,22.43H21.7a2.86,2.86,0,0,0,2.94-2.773V17.774A2.86,2.86,0,0,0,21.7,15H16.438A2.86,2.86,0,0,0,13.5,17.774v1.881A2.86,2.86,0,0,0,16.438,22.43Z"
                    transform="translate(6.857 9.429)"
                    fill="none"
                    stroke="#888"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="1.5"
                    fillRule="evenodd"
                  />
                </g>
              </svg>
            </span>
            <span className="text">Dashboard</span>
          </NavLink>
        )}

        {getPermissionRightsForMenu(jobListPerm) && (
          <NavLink className="nav-link" activeclassname="active" to="/job-list">
            <span className="icon fill-svg">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="33"
                height="27.164"
                viewBox="0 0 33 27.164"
              >
                <g id="Layer_x0020_1" transform="translate(-8.72 -82.04)">
                  <path
                    id="Path_626"
                    data-name="Path 626"
                    d="M13.89,87.223h4.819a6.028,6.028,0,0,1,5.952-5.183h1.118a6.028,6.028,0,0,1,5.952,5.183H36.55a5.183,5.183,0,0,1,5.17,5.171v11.64a5.183,5.183,0,0,1-5.17,5.171H13.89a5.183,5.183,0,0,1-5.17-5.171V92.394A5.183,5.183,0,0,1,13.89,87.223Zm3.945,13.968L15.6,104.368a.824.824,0,0,1-1.347-.948l2.235-3.178a4.31,4.31,0,1,1,1.347.948ZM19.6,94.577a2.671,2.671,0,1,0,2.671,2.671A2.671,2.671,0,0,0,19.6,94.577Zm7.247,10.592a.825.825,0,0,1,0-1.65h7.644a.825.825,0,0,1,0,1.65Zm0-4.863a.825.825,0,0,1,0-1.65h7.644a.825.825,0,0,1,0,1.65Zm0,2.431a.825.825,0,0,1,0-1.65h7.644a.825.825,0,0,1,0,1.65Zm0-4.863a.825.825,0,0,1,0-1.65h7.644a.825.825,0,0,1,0,1.65Zm0-4.579a.825.825,0,0,1,0-1.65h6.13a.825.825,0,0,1,0,1.65Zm-6.467-6.073h9.676a4.378,4.378,0,0,0-4.279-3.533H24.661a4.378,4.378,0,0,0-4.279,3.533Zm16.168,1.65H13.89a3.534,3.534,0,0,0-3.52,3.521v11.64a3.533,3.533,0,0,0,3.52,3.52H36.55a3.533,3.533,0,0,0,3.52-3.52V92.394A3.534,3.534,0,0,0,36.55,88.873Z"
                    transform="translate(0)"
                    fill="#888"
                  />
                </g>
              </svg>
            </span>
            <span className="text">Job Lists</span>
          </NavLink>
        )}

        {getPermissionRightsForMenu(candidatePerm) && (
          <NavLink className="nav-link" activeclassname="active" to="/candidate">
            <span className="icon strok-svg">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="31.5"
                height="25.5"
                viewBox="0 0 31.5 25.5"
              >
                <g id="user-id-svgrepo-com" transform="translate(-1.25 -3.25)">
                  <circle
                    id="Ellipse_118"
                    data-name="Ellipse 118"
                    cx="3"
                    cy="3"
                    r="3"
                    transform="translate(9.5 8.5)"
                    fill="none"
                    stroke="#888"
                    strokeWidth="1.5"
                  />
                  <path
                    id="Path_621"
                    data-name="Path 621"
                    d="M17,16c0,1.657,0,3-6,3s-6-1.343-6-3,2.686-3,6-3S17,14.343,17,16Z"
                    transform="translate(1.5 4.5)"
                    fill="none"
                    stroke="#888"
                    strokeWidth="1.5"
                  />
                  <path
                    id="Path_622"
                    data-name="Path 622"
                    d="M32,16c0,5.657,0,8.485-1.757,10.243S25.657,28,20,28H14c-5.657,0-8.485,0-10.243-1.757S2,21.657,2,16,2,7.515,3.757,5.757,8.343,4,14,4h6c5.657,0,8.485,0,10.243,1.757A5.262,5.262,0,0,1,31.622,8.5"
                    transform="translate(0 0)"
                    fill="none"
                    stroke="#888"
                    strokeLinecap="round"
                    strokeWidth="1.5"
                  />
                  <path
                    id="Path_623"
                    data-name="Path 623"
                    d="M21,12H15"
                    transform="translate(6.5 4)"
                    fill="none"
                    stroke="#888"
                    strokeLinecap="round"
                    strokeWidth="1.5"
                  />
                  <path
                    id="Path_624"
                    data-name="Path 624"
                    d="M21.5,9H14"
                    transform="translate(6 2.5)"
                    fill="none"
                    stroke="#888"
                    strokeLinecap="round"
                    strokeWidth="1.5"
                  />
                  <path
                    id="Path_625"
                    data-name="Path 625"
                    d="M20.5,15H16"
                    transform="translate(7 5.5)"
                    fill="none"
                    stroke="#888"
                    strokeLinecap="round"
                    strokeWidth="1.5"
                  />
                </g>
              </svg>
            </span>
            <span className="text">Candidates</span>
          </NavLink>
        )}

        {getPermissionRightsForMenu(usersPerm) && (
          <NavLink className="nav-link" activeclassname="active" to="/user">
            <span className="icon strok-svg">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="32.5"
                height="21.227"
                viewBox="0 0 32.5 21.227"
              >
                <path
                  id="users-more-svgrepo-com"
                  d="M3.818,24.727H1V23.318a5.639,5.639,0,0,1,4.227-5.459m2.818-4.645a4.229,4.229,0,0,1,0-7.973M29.182,24.727H32V23.318a5.639,5.639,0,0,0-4.227-5.459M24.955,5.241a4.229,4.229,0,0,1,0,7.973M13.682,17.682h5.636a5.636,5.636,0,0,1,5.636,5.636v1.409H8.045V23.318A5.636,5.636,0,0,1,13.682,17.682Zm7.045-8.455A4.227,4.227,0,1,1,16.5,5,4.227,4.227,0,0,1,20.727,9.227Z"
                  transform="translate(-0.25 -4.25)"
                  fill="none"
                  stroke="#888"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="1.5"
                />
              </svg>
            </span>
            <span className="text">Users</span>
          </NavLink>
        )}

        {getPermissionRightsForMenu(reportPerm) && (
          <NavLink className="nav-link" activeclassname="active" to="/">
            <span className="icon fill-svg">
              <svg
                id="report-svgrepo-com"
                xmlns="http://www.w3.org/2000/svg"
                width="30"
                height="30"
                viewBox="0 0 30 30"
              >
                <g id="Group_1934" data-name="Group 1934">
                  <g id="Group_1933" data-name="Group 1933">
                    <path
                      id="Path_628"
                      data-name="Path 628"
                      d="M29.388,19.9h-.306V2.755a.612.612,0,0,0-.612-.612h-10.1V.612A.612.612,0,0,0,17.755,0h-5.51a.612.612,0,0,0-.612.612V2.143H1.531a.612.612,0,0,0-.612.612V19.9H.612A.612.612,0,0,0,0,20.51v2.143a.612.612,0,0,0,.612.612H9.939l-3.117,5.2,1.05.63,3.5-5.825h3.021V30h1.224V23.265h3.021l3.5,5.825,1.05-.63-3.117-5.2h9.327A.612.612,0,0,0,30,22.653V20.51A.612.612,0,0,0,29.388,19.9ZM12.857,1.224h4.286v.918H12.857ZM2.143,3.367H27.857V19.9H2.143ZM28.776,22.041H1.224v-.918H28.776Z"
                      fill="#888"
                    />
                    <path
                      id="Path_629"
                      data-name="Path 629"
                      d="M76.122,90a6.122,6.122,0,1,0,6.122,6.122A6.129,6.129,0,0,0,76.122,90Zm0,11.02a4.9,4.9,0,0,1-.612-9.756v4.858a.612.612,0,0,0,.612.612h4.858A4.9,4.9,0,0,1,76.122,101.02Zm.612-5.51V91.264a4.906,4.906,0,0,1,4.246,4.246Z"
                      transform="translate(-65.714 -84.49)"
                      fill="#888"
                    />
                    <rect
                      id="Rectangle_611"
                      data-name="Rectangle 611"
                      width="4.286"
                      height="1.224"
                      transform="translate(21.122 7.959)"
                      fill="#888"
                    />
                    <rect
                      id="Rectangle_612"
                      data-name="Rectangle 612"
                      width="4.286"
                      height="1.224"
                      transform="translate(21.122 9.796)"
                      fill="#888"
                    />
                    <rect
                      id="Rectangle_613"
                      data-name="Rectangle 613"
                      width="4.286"
                      height="1.224"
                      transform="translate(21.122 11.633)"
                      fill="#888"
                    />
                    <rect
                      id="Rectangle_614"
                      data-name="Rectangle 614"
                      width="2.755"
                      height="1.224"
                      transform="translate(21.122 6.122)"
                      fill="#888"
                    />
                    <path
                      id="Path_630"
                      data-name="Path 630"
                      d="M262.034,101.223V100h-2.755a.612.612,0,0,0-.433.179l-.918.918.866.866.739-.739Z"
                      transform="translate(-242.136 -93.877)"
                      fill="#888"
                    />
                    <rect
                      id="Rectangle_615"
                      data-name="Rectangle 615"
                      width="7.041"
                      height="1.224"
                      transform="translate(18.98 14.388)"
                      fill="#888"
                    />
                    <rect
                      id="Rectangle_616"
                      data-name="Rectangle 616"
                      width="8.878"
                      height="1.224"
                      transform="translate(17.143 16.531)"
                      fill="#888"
                    />
                  </g>
                </g>
              </svg>
            </span>
            <span className="text">Reports</span>
          </NavLink>
        )}

        {getPermissionRightsForMenu(settingsPerm) && (
          <NavLink className="nav-link" activeclassname="active" to="/settings">
            <span className="icon strok-svg">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="29.792"
                height="31.5"
                viewBox="0 0 29.792 31.5"
              >
                <g id="settings-svgrepo-com" transform="translate(-1.818 -1.25)">
                  <circle
                    id="Ellipse_119"
                    data-name="Ellipse 119"
                    cx="4.5"
                    cy="4.5"
                    r="4.5"
                    transform="translate(12.214 12.5)"
                    fill="none"
                    stroke="#888"
                    strokeWidth="1.5"
                  />
                  <path
                    id="Path_627"
                    data-name="Path 627"
                    d="M4.206,14.959a2.371,2.371,0,0,1,0,4.082,3.7,3.7,0,0,0-1.014.833A3,3,0,0,0,2.6,22.092,7.483,7.483,0,0,0,3.724,24.5a7.483,7.483,0,0,0,1.522,2.179,3,3,0,0,0,2.218.594,3.7,3.7,0,0,0,1.229-.462,2.371,2.371,0,0,1,3.536,2.041,3.7,3.7,0,0,0,.215,1.3,3,3,0,0,0,1.624,1.624A7.484,7.484,0,0,0,16.714,32a7.484,7.484,0,0,0,2.648-.228,3,3,0,0,0,1.624-1.624,3.7,3.7,0,0,0,.215-1.295,2.371,2.371,0,0,1,3.535-2.041,3.7,3.7,0,0,0,1.229.462,3,3,0,0,0,2.218-.594A7.482,7.482,0,0,0,29.7,24.5c.311-.539.553-.958.732-1.309m-1.215-4.15a2.371,2.371,0,0,1,0-4.082,3.7,3.7,0,0,0,1.014-.833,3,3,0,0,0,.594-2.218A7.48,7.48,0,0,0,29.7,9.5a7.481,7.481,0,0,0-1.522-2.179,3,3,0,0,0-2.218-.594,3.7,3.7,0,0,0-1.229.462A2.371,2.371,0,0,1,21.2,5.147a3.7,3.7,0,0,0-.215-1.3,3,3,0,0,0-1.624-1.624A7.482,7.482,0,0,0,16.714,2a7.482,7.482,0,0,0-2.648.228,3,3,0,0,0-1.624,1.624,3.7,3.7,0,0,0-.215,1.295A2.371,2.371,0,0,1,8.692,7.188a3.7,3.7,0,0,0-1.229-.462,3,3,0,0,0-2.218.594A7.482,7.482,0,0,0,3.724,9.5c-.311.539-.553.958-.733,1.309"
                    fill="none"
                    stroke="#888"
                    strokeLinecap="round"
                    strokeWidth="1.5"
                  />
                </g>
              </svg>
            </span>
            <span className="text">Settings</span>
          </NavLink>
        )}
      </nav>
    </section>
  );
}
